import { studentCoursesListActionTypes as types } from 'Screens_old';
import initialState from 'Store/InitialState';

export default function studentCoursesListReducer(state = initialState.studentCoursesMap, action) {
    let newState;
    switch (action.type) {
        case types.LOAD_STUDENT_COURSES_LIST_SUCCESS:
            return action.studentCoursesMap;
        case types.UNREGISTER_COURSE_SUCCESS:
            newState = new Map(state);
            newState.delete(action.courseId);
            return newState;
        default:
            return state;
    }
};
